import { MemberFieldApi, WebApiMemberFieldsDtoAddMemberFieldDto, WebApiMemberFieldsDtoSaveMemberFieldSettingsDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class MemberFieldService {

    public static CreateMemberUploadTemplate = async () => {
        return new MemberFieldApi(GetApiConfiguration()).apiMemberFieldCreateMemberUploadTemplatePostRaw();

    }

    public static GetMemberFields = async () => {
        return new MemberFieldApi(GetApiConfiguration()).apiMemberFieldGetMemberFieldsGet();
    };

    public static GetUnusedMemberFields = async () => {
        return new MemberFieldApi(GetApiConfiguration()).apiMemberFieldGetUnusuedMemberFieldsGet();
    };

    public static GetMemberUploadFields = async () => {
        return new MemberFieldApi(GetApiConfiguration()).apiMemberFieldGetMemberUploadFieldsGet();
    };

    public static AddNewField = async (dto: WebApiMemberFieldsDtoAddMemberFieldDto) => {
        return new MemberFieldApi(GetApiConfiguration()).apiMemberFieldAddMemberFieldPost({
            webApiMemberFieldsDtoAddMemberFieldDto: dto
        });
    };

    public static SaveMemberFields = async (request: WebApiMemberFieldsDtoSaveMemberFieldSettingsDto) => {
        return new MemberFieldApi(GetApiConfiguration()).apiMemberFieldSaveMemberFieldsPost({
            webApiMemberFieldsDtoSaveMemberFieldSettingsDto: request
        });
    };
}